<template>
    <div class="notification">
        <b-dropdown
            right
            class="notification-dropdown"
            @show="fetchNotification()"
            @hide="showUnread = false"
            no-flip
            ref="notificationDropdown"
        >
            <template #button-content>
                <NotificationBell
                    :is-read="notificationUnread <= 0"
                    class="cursor-pointer"
                ></NotificationBell>
            </template>
            <div class="dropdown-container" :class="{ loading }">
                <div class="dropdown-header px-3 pt-3">
                    <div>
                        <b class="text-allports text-lg">
                            {{ $t('notification.notification') }}
                        </b>
                        <b-form-checkbox
                            v-model="showUnread"
                            class="mt-1"
                            name="check-button"
                            @change="fetchNotification(showUnread)"
                            switch
                        >
                            {{ $t('notification.show_unread') }}
                        </b-form-checkbox>
                    </div>
                </div>
                <div class="dropdown-list-item">
                    <div v-if="shownNotification.length > 0">
                        <div
                            v-for="(item, index) in shownNotification"
                            @click.stop="goToNotificationLink(item)"
                            :key="index"
                            class="border-bottom dropdown-item"
                        >
                            <div class="col-1">
                                <div
                                    class="bell-container d-inline-block"
                                    @click.stop="setRead(item)"
                                >
                                    <NotificationBell :is-read="item.isRead">
                                    </NotificationBell>
                                </div>
                            </div>
                            <div class="col-11">
                                <div
                                    class="text-ellipsis w-100 overflow-hidden"
                                    :title="item.title"
                                >
                                    <b class="text-allports">
                                        {{ item.title }}
                                    </b>
                                </div>
                                <div
                                    :title="item.content"
                                    class="text-ellipsis w-100 overflow-hidden"
                                >
                                    <span class="text-sm">
                                        {{ item.content }}
                                    </span>
                                </div>
                                <div>
                                    <span class="text-sm text-regent-grey">
                                        {{
                                            $helpers.formatTimeAgo(
                                                item.createdAt
                                            )
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="dropdown-item">
                            <div class="w-100 text-center">
                                {{ $t('notification.no_notification') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="dropdown-footer p-3 position-relative"
                    @click="$refs.notificationDropdown.hide(true)"
                >
                    <b-link
                        :to="{ name: 'notification' }"
                        class="stretched-link"
                    >
                        <div class="w-100 text-center">
                            <b class="text-maya-blue text-lg">
                                {{ $t('notification.see_all') }}
                            </b>
                        </div>
                    </b-link>
                </div>
            </div>
        </b-dropdown>
    </div>
</template>

<script>
import NotificationBell from '@/components/utils/NotificationBell/NotificationBell';
import { getNotificationsList } from '@/services/notification.service';
import { mapActions, mapGetters } from 'vuex';
import {
    MAX_NOTIFICATION_DROPDOWN,
    NOTIFICATION_STATE,
} from '@/constants/notification';
export default {
    name: 'NotificationDropdown',
    components: { NotificationBell },
    data() {
        return {
            notifications: [],
            showUnread: false,
            loading: true,
        };
    },
    async created() {
        this.fetchNotification();
    },
    watch: {
        notificationPayload: {
            deep: true,
            immediate: true,
            handler(value) {
                if (value) {
                    this.notifications.unshift(value);
                }
            },
        },
    },
    computed: {
        ...mapGetters('notification', [
            'notificationUnread',
            'notificationPayload',
        ]),
        shownNotification() {
            return this.notifications.slice(0, MAX_NOTIFICATION_DROPDOWN);
        },
    },
    methods: {
        ...mapActions('notification', ['fetchUnread', 'readNotification']),
        async goToNotificationLink(item) {
            this.loading = true;
            const { id, link, isRead } = item;
            if (!isRead) {
                item.isRead = true;
                await this.readNotification(id);
            }

            if (link) {
                this.$refs.notificationDropdown.hide(true);
                location.href = link;
            }
            this.loading = false;
        },
        fetchNotification(showUnread = false) {
            this.loading = true;
            const params = {
                limit: MAX_NOTIFICATION_DROPDOWN,
                page: 1,
                ...(showUnread && { state: NOTIFICATION_STATE.UNREAD.key }),
            };
            getNotificationsList(params)
                .then((res) => {
                    const { unread, notifications } = res.data;
                    this.notifications = notifications;
                    this.$store.commit('notification/setUnread', unread);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        setRead(item) {
            const { id, isRead } = item;
            if (!isRead) {
                this.readNotification(id);
                item.isRead = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'NotificationDropdown';
</style>
